import { render, staticRenderFns } from "./SignUpThx.vue?vue&type=template&id=1a4d0591&"
import script from "./SignUpThx.vue?vue&type=script&lang=js&"
export * from "./SignUpThx.vue?vue&type=script&lang=js&"
import style0 from "./SignUpThx.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports